import React from 'react';
import { string, node } from 'prop-types';
import classnames from 'classnames';
import './Icon.scss';

export default function Icon({ className, children, ...otherProps }) {
    const rootClassnames = classnames('icons-root', className);
    return (
        <svg
            version="1.1"
            className={rootClassnames}
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            {...otherProps}
        >
            {children}
        </svg>
    );
}

Icon.propTypes = {
    className: string,
    children: node.isRequired,
};

Icon.defaultProps = {
    className: null,
};
